import { render, staticRenderFns } from "./baseAirServiceProduct.vue?vue&type=template&id=b2d8d5c4&"
import script from "./baseAirServiceProduct.vue?vue&type=script&lang=js&"
export * from "./baseAirServiceProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b2d8d5c4')) {
      api.createRecord('b2d8d5c4', component.options)
    } else {
      api.reload('b2d8d5c4', component.options)
    }
    module.hot.accept("./baseAirServiceProduct.vue?vue&type=template&id=b2d8d5c4&", function () {
      api.rerender('b2d8d5c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Information/components/basicData/baseAirServiceProduct.vue"
export default component.exports